import { AnimatePresence, motion } from 'motion/react'
import { useMemo } from 'react'
import ThreeDSlider from './ThreeDSlider'


export const captions = [
    <span>LearnTube Founders Recognised at <span className='text-[#83BEFF] font-bold'>Premier Google Event</span></span>,
    <span>Selected Among <span className='text-[#83BEFF] font-bold'>Top 20 AI Startups</span></span>,
    <span>Shronit Talking About <span className='text-[#83BEFF] font-bold'>Building The Future of Education</span></span>,
    <span>LearnTube's Story on <span className='text-[#83BEFF] font-bold'>TV's #1 Startup Show</span></span>,
    <span>Founder On-Stage At A <span className='text-[#83BEFF] font-bold'>Global Creator Summit</span></span>,
    <span>Founder On-Stage At <span className='text-[#83BEFF] font-bold'>World's #1 Tech Conference</span></span>,
    <span>2024 Milestone: <span className='text-[#83BEFF] font-bold'>Helping 400K+ People Upskill!</span></span>,
    <span>LearnTube Making Headlines On<span className='text-[#83BEFF] font-bold'> Top Media Platforms</span></span>,
    <span>Awarded The Coveted <span className='text-[#83BEFF] font-bold'>40 U 40</span></span>,
    <span>Received <span className='text-[#83BEFF] font-bold'>Countless Global Awards</span></span>
]

export const new3DSlider = [
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20136.webp?updatedAt=1745649696325',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20137.webp?updatedAt=1745649696104',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20138.webp?updatedAt=1745649696094',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20139.webp?updatedAt=1745649892976',
    'https://img.learntube.ai/public-assets/new%20Linkedin%20data/Property%201=3.png?updatedAt=1746773868985',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20140.webp?updatedAt=1745649892320',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20141.webp?updatedAt=1745649892361',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20142.png?updatedAt=1745649981938',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20136-1.webp?updatedAt=1745649892357',
    'https://img.learntube.ai/public-assets/linkedinpost/Component%20136-2.webp?updatedAt=1745649892286'
]

const NewAwardSection = ({ index }) => {

    const imageLink = useMemo(() => {
        return index === 0 ? 'https://img.learntube.ai/public-assets/new%20Linkedin%20data/Frame%20427321191.png?updatedAt=1747220801701' : index === 1 ? 'https://img.learntube.ai/public-assets/new%20Linkedin%20data/Frame%20427321192.png?updatedAt=1747220801729' : 'https://img.learntube.ai/public-assets/new%20Linkedin%20data/Frame%20427321193.png?updatedAt=1747220801582'
    }, [index])


    return (
        <div
            className='text-white rounded-3xl bg-[#103450] pt-10 pb-10 md:rounded-xl'
            style={{
                backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%)'
            }}
        >
            <div className='relative'>
                <div className='px-[22px]'>
                    <h2 className='text-[32px] text-center text-transparent bg-clip-text bg-gradient-to-r from-white to-[#406AFF] leading-[100%] md:text-[34px]'>
                        Join our <span className='font-bold'>Award Winning</span> Platform
                    </h2>
                    <div className='mt-6 flex items-center justify-center gap-1'>
                        <img alt="" src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/Group%2022953.png?updatedAt=1750530039545" className="w-full" />

                    </div>
                </div>
                <ThreeDSlider />
                <div className='text-white/50 text-[16px] text-center mt-4 md:text-[18px]'>Swipe for more →</div>
                {/* <img src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/Frame%20427321214%20(2).png?updatedAt=1746773625338" width={'100%'} height={100} className='z-20 -bottom-[8%] absolute w-[110%] h-auto' alt="" /> */}
                <div className="border border-[#83BEFF]/30 w-full my-10" />
            </div>
            <div className=' w-full relative pb-10'>
                <h4 className='px-[22px] relative z-20 text-xl text-transparent bg-clip-text bg-gradient-to-r from-white to-[#406AFF] leading-[100%] text-center mt-2 md:-mt-2'>We have been <span className='font-bold'>featured by</span></h4>
                <div className='mt-2 overflow-y-visible flex justify-center'>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.5 }}
                            className="flex p-[22px] absolute items-center justify-between gap-[26px]"
                        >
                            <img src={imageLink} loading='eager' alt="" />
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    )
}

export default NewAwardSection